import React, { useState } from 'react';

// @ts-ignore
import styles from './MedicalRequestsListItem.module.scss';
import { useAppContext } from '../../../../Services/AppContext';
import Button from '../../../../Components/Button/Button';
import { Theme } from '../../../../Enums/Theme.enum';
import MediaViewerModal from '../../../../Components/MediaViewer/MediaViewerModal';
import { getMomentDate } from '../../../../Utils/dates.util';
import useTranslation from '../../../../Hooks/useTranslation';
import FormattedMomentDate, {
	DateFormat,
} from '../../../Base/Components/FormattedMomentDate/FormattedMomentDate';

interface Props {
	item: {
		id: string;
		createdAt: string;
		title: {
			extra: {
				text: string;
			};
		};
	};
}

const MedicalRequestsListItem: React.FC<Props> = ({ item }) => {
	const [isMediaViewerOpened, setIsMediaViewerOpened] = useState(false);
	const { t } = useTranslation();
	const { socketUrl } = useAppContext();

	const fileToViewer = {
		id: item.id,
		name: item.title?.extra?.text,
		displayName: item.title?.extra?.text,
		type: 'pdf',
		preview: socketUrl + '/document/' + item.id + '/pdf/download',
		download: socketUrl + '/document/' + item.id + '/pdf/download',
	};

	return (
		<div className={styles.wrapper}>
			<div className={styles.date}>
				<FormattedMomentDate
					date={item.createdAt}
					format={DateFormat.DATE_TIME}
				/>
			</div>
			<div className={styles.title}>{item.title?.extra?.text}</div>
			<div className={styles.controls}>
				<Button
					onClick={() => setIsMediaViewerOpened(true)}
					title={t('base.detail')}
					theme={Theme.GREEN}
				/>
			</div>
			<MediaViewerModal
				opened={isMediaViewerOpened}
				onClose={() => setIsMediaViewerOpened(false)}
				file={fileToViewer}
			/>
		</div>
	);
};

export default MedicalRequestsListItem;
